export const SET_PROFILE = "SET_PROFILE"
export const SET_RECORDS = "SET_RECORDS"
export const SET_RECORD = "SET_RECORD"
export const SET_RECORD_SHELL = "SET_RECORD_SHELL"
export const SET_SUBRECORD = "SET_SUBRECORD"
export const SET_EDITED_RECORD = "SET_EDITED_RECORD"
export const UNSET_RECORD = "UNSET_RECORD"
export const UNSET_RECORDS = "UNSET_RECORDS"
export const UNSET_SUBRECORD = "UNSET_SUBRECORD"
export const SET_REPORT = "SET_REPORT"

export const EDIT_RECORD = "EDIT_RECORD"

export const SET_SETTINGS = "SET_SETTINGS"
export const SET_GRAPH_DATA = "SET_GRAPH_DATA"
export const SET_CATEGORIES = "SET_CATEGORIES"
export const SET_DASHBOARD_WORKLOAD = "SET_DASHBOARD_WORKLOAD"
export const SET_HOLIDAYS = "SET_HOLIDAYS"

export const SET_APP_CONTEXT = "SET_APP_CONTEXT"
export const SET_ROUTE_STATE = "SET_ROUTE_STATE"
export const SET_CONTEXT_STATE = "SET_CONTEXT_STATE"
export const SET_CONTEXT_STATE_VALUE = "SET_CONTEXT_STATE_VALUE"
